import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { MapTo } from "@adobe/aem-react-editable-components";
import { LoyaltyPointsStatus } from "@jti/loyalty";
import { selectIsUserDataFetching } from "@jti/store";
import { Loading } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
import styles from "./LoyaltyPointsStatus.module.scss";
export const loyaltyPointsStatusEditConfig = {
    emptyLabel: "LoyaltyPointsStatus",
    isEmpty: (props) => !props.tiers || !props.pointsHistoryLabel || !props.pointsHistoryUrl,
    getProps: (props) => ({
        tiers: props.tiers,
        ctaButtonLabel: props.ctaButtonLabel,
        ctaButtonUrl: props.ctaButtonUrl,
        secondaryCtaButtonLabel: props.secondaryCtaButtonLabel,
        secondaryCtaButtonUrl: props.secondaryCtaButtonUrl,
        pointsHistoryLabel: props.pointsHistoryLabel,
        pointsHistoryUrl: props.pointsHistoryUrl,
        isInEditor: props.isInEditor,
    }),
};
export const LoyaltyPointsStatusWrapper = (props) => {
    const isUserDataFetching = useSelector(selectIsUserDataFetching);
    if (isUserDataFetching) {
        return (_jsx("div", { className: styles.container, children: _jsx(Loading, { dataTestId: "loyalty-points-status-loader" }) }));
    }
    return _jsx(LoyaltyPointsStatus, { ...props });
};
export default MapTo("loyalty/components/loyalty-points-status")(withAemAuthoring(LoyaltyPointsStatusWrapper, loyaltyPointsStatusEditConfig));
